import db from '@/js/services/contracts/Database';
import Dexie from 'dexie';

export default {
  getAll() {
    return db.farmers.where('sync_status').notEqual(2).toArray();
  },
  updateById(id, updateObj) {
    db.farmers.update(id, Dexie.deepClone(updateObj)).then((updated) => updated);
  },
  getById(ids) {
    return db.farmers.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  add(data) {
    return db.farmers.add(Dexie.deepClone(data));
  },
  deleteById(id) {
    return db.farmers.where('id').equals(id).delete();
  },
  getAllSyncPending() {
    return db.farmers.where('sync_status').equals(1).toArray();
  },
  async getFarmersFullInfo(ids) {
    const farmers = (ids === undefined) ? await db.farmers.with({ fields: 'fields' })
      : await db.farmers.where('id').anyOf(ids).with({ fields: 'fields' });
    // Elimino las fincas para hacer la relacion por codigo mas abajo

    farmers.forEach((farmer) => {
      farmer.fields = [];
    });
    // Se crea una simulada relacion 1 a M entre fincas y proveedores
    const fields = await db.fields.toArray();
    fields.forEach((field) => {
      if (field.farmers !== undefined) {
        field.farmers.forEach((element) => {
          farmers.forEach((farmer) => {
            if (element === farmer.id) {
              const contenido = farmer.fields;
              contenido.push(field);
              farmer.fields = contenido;
            }
          });
        });
      }
    });

    let fieldIds = farmers.map((farmer) => farmer.fields.map((field) => field.id));
    // fieldIds = [].concat([], ...fieldIds);
    fieldIds = fieldIds.flat();
    const crops = await db.crops.where('field').anyOf(fieldIds).and((item) => item.sync_status !== 2)
      .toArray();
    const contracts = await db.contracts.where('field').anyOf(fieldIds).and((item) => item.sync_status !== 2)
      .toArray();

    farmers.forEach((farmer) => {
      farmer.fields.forEach((field) => {
        const cropsInField = crops.filter((c) => field.id === c.field);
        const contractsInField = contracts.filter((c) => field.id === c.field);
        field.crops = cropsInField;
        field.contracts = contractsInField;
      });
    });
    return farmers;
  },

};
